import { render, staticRenderFns } from "./updateInstitutionAvailabilitiesDialog.vue?vue&type=template&id=62a1164f"
import script from "./updateInstitutionAvailabilitiesDialog.vue?vue&type=script&lang=ts"
export * from "./updateInstitutionAvailabilitiesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports